import axios from 'axios'
 
export const conversation = (conversion_identifier, { company_name, name, email, city, state, mobile_phone }) => {
    return axios.post('https://api.rd.services/platform/conversions?api_key=qLrSmLXMwNGSgRfSZEzhLMsllScUiMAsfImn', {
        event_family: 'CDP',
        event_type: 'CONVERSION',
        payload: {
            conversion_identifier,
            company_name,
            name,
            email,
            city,
            state,
            mobile_phone,
            available_for_mailing: true,
        }
    }).then(({ data }) => data)
}

const $RDStation = {
    conversation,
}

export default $RDStation
